export function Grow() {
  return <span style={{ flexGrow: 1 }} />;
}
